import React, { FC, forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core';
import { ReactComponent as ConstructionIconSvg } from './constructionIconSvg.svg';
import { ReactComponent as EngineeringIconSvg } from './engineeringIconSvg.svg';
import { ReactComponent as ExpandIconSvg } from './expandIconSvg.svg';

export const ConstructionIcon: FC<SvgIconProps> = forwardRef((props, ref) => <ConstructionIconSvg ref={ref} {...props} />);
export const EngineeringIcon: FC<SvgIconProps> = forwardRef((props, ref) => <EngineeringIconSvg ref={ref} {...props} />);
export const ExpandIcon: FC<SvgIconProps> = forwardRef((props, ref) => <ExpandIconSvg ref={ref} {...props} />);
